import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, inject, Input, OnChanges, OnInit, signal, SimpleChanges } from '@angular/core';
import { ClaimService } from '../../service/claim.service';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ClaimStatusData } from '../../interfaces/claim-status.interface';

@Component({
  selector: 'reclaim-order',
  imports: [CommonModule, NgxSkeletonLoaderModule],
  templateUrl: `./reclaim-order.component.html`,
  styleUrl: './reclaim-order.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReclaimOrderComponent implements OnInit, OnChanges {

  constructor() {
    effect(() => {
      if (this.loadStatusReclaim) {
        this.claimStatus();
      }
    })
  }

  claimService = inject(ClaimService);
  @Input() orderId: number = 0;
  @Input() loadStatusReclaim: boolean = false;

  OrderData = signal<ClaimStatusData>({} as ClaimStatusData);
  statusMap = signal<Map<string, string>>(new Map([
    // Variantes en español
    ['Aprobado', 'bg-green-500'],

    ['Rechazado', 'bg-red-500'],

    ['En revisión', 'bg-yellow-500'],



  ]));

  ngOnInit(): void {
    // console.log('order id', this.orderId);

    this.claimStatus();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['orderId']) {
      this.claimStatus();
    }
    if (changes['loadStatusReclaim']) {
      this.claimStatus();
    }
  }

  claimStatus(): void {
    this.claimService.checkStatusClaim(this.orderId).subscribe({
      next: (res) => {
        // Asignar el primer elemento de la respuesta al signal
        this.OrderData.set(res?.data?.[0] ?? ({} as ClaimStatusData));
      },
      error: (err) => {
        // console.log(err);
      }
    })
  }
}
